import React, {  useRef,useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { ENDPOINT } from "constants/variables";
import IconButton from '@mui/material/IconButton'; 
import DeleteIcon from '@mui/icons-material/Delete';
import MenuItem  from "@mui/material/MenuItem";
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography'; 
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import ContractSearchStores from "pages/contracts/editOrNewContract/ContractSearchStores";
import ContractSearchEmployees from "pages/contracts/editOrNewContract/ContractSearchEmployee";
import ContractSearchStoresAddresses from "pages/contracts/editOrNewContract/ContractSearchStoresAddress";
import ContractSearchStoresNimaAddresses from "pages/contracts/editOrNewContract/ContractSearchStoresNimaAddress";
import PropTypes from 'prop-types';

const initialPostalCodesToSelect = [{
    "id":0,
    "postalcode":"",
    "name":"",
    "postalcodename":"",
    "enabled":true,
    "province_id":0
}];

const initialDocumentIdToSelect = [{
    "id": 0,
    "documentid": "",
    "tradename": ""
}];

const initialNimaToSelect = [{
    "id":0,
    "nima":""
}];

const ContractCreateOrEditOriTras = ({formContract,setFormContract,setIsLoadingErrorData,errorsForm,setErrorsForm,validateFormContract,documentTypesToSelect,roadTypesToSelect,communityToSelect,expanded,optTypeToSelect}) => {
    const {t,i18n} = useTranslation(['listDataContracts']);
    const token = useSelector((state) => state.loginUser.token); 
    const roles = useSelector((state) => state.loginUser.roles);  
    const DEFAULTTYPEOFDOCUMENT = useSelector((state) => state.formatDIUser.default_documenttype); 
    const DEFAULTROADTYE = useSelector((state) => state.formatDIUser.default_roadtype); 
    const DEFAULTCOUNTRY = useSelector((state) => state.formatDIUser.default_country); 
    const DEFAULTCOUNTRY_NAME = useSelector((state) => state.formatDIUser.default_country_name); 
    const DEFAULTPROVINCE = useSelector((state) => state.formatDIUser.default_province); 
    const DEFAULTPROVINCE_NAME = useSelector((state) => state.formatDIUser.default_province_name); 
    const DEFAULTPOSTALCODE_ID = useSelector((state) => state.formatDIUser.default_postalcode); 
    const DEFAULTPOSTALCODE_CODE = useSelector((state) => state.formatDIUser.default_postalcode_code); 
    const DEFAULTPOSTALCODE_NAME = useSelector((state) => state.formatDIUser.default_postalcode_name); 
    const DEFAULTCOMMUNITY = useSelector((state) => state.formatDIUser.default_community); 
    const DEFAULTCOMMUNITY_NAME = useSelector((state) => state.formatDIUser.default_community_name); 
    const [showModalSearchStores, setShowModalSearchStores] = useState(false); 
    const [showModalSearchEmployees, setShowModalSearchEmployees] = useState(false); 
    const [showModalSearchStoresAddress, setShowModalSearchStoresAddress] = useState(false);  
    const [showModalSearchStoresNimaAddress, setShowModalSearchStoresNimaAddress] = useState(false);          
    const [priority, setPriority] = useState(1);   
    const [tetxtSearch, setTetxtSearch] = useState("Ori_Tras");   
    const dispatch = useDispatch(); 
    const [postalCodeOriTrasToSelect,setPostalCodeOriTrasToSelect]= useState(initialPostalCodesToSelect);  
    const [filteredpostalCodeOriTras, setFilteredpostalCodeOriTras] = useState([]); // Opciones filtradas
    const [highlightedIndexPostalCodeOriTras, setHighlightedIndexPostalCodeOriTras] = useState(-1); // Índice de la opción resaltada 
    const [postalCodeOriTrasFiscalToSelect,setPostalCodeOriTrasFiscalToSelect]= useState(initialPostalCodesToSelect);  
    const [filteredpostalCodeOriTrasFiscal, setFilteredpostalCodeOriTrasFiscal] = useState([]); // Opciones filtradas
    const [highlightedIndexPostalCodeOriTrasFiscal, setHighlightedIndexPostalCodeOriTrasFiscal] = useState(-1); // Índice de la opción resaltada 
    const [documentIdOriTrasToSelect,setDocumentIdOriTrasToSelect]= useState(initialDocumentIdToSelect);  
    const [filteredDocumentIdOriTras, setFilteredDocumentIdOriTras] = useState([]); // Opciones filtradas
    const [highlightedIndexDocumentIdOriTras, setHighlightedIndexDocumentIdOriTras] = useState(-1); // Índice de la opción resaltada 
    const [tradenameOriTrasToSelect,setTradenameOriTrasToSelect]= useState(initialDocumentIdToSelect);  
    const [filteredTradenamedOriTras, setFilteredTradenamedOriTras] = useState([]); // Opciones filtradas
    const [highlightedIndexTradenamedOriTras, setHighlightedIndexTradenamedOriTras] = useState(-1); // Índice de la opción resaltada 
    const [oriTrasNimaToSelect,setOriTrasNimaToSelect]= useState(initialNimaToSelect);  
    const [filteredOriTrasNima, setFilteredOriTrasNima] = useState([]); // Opciones filtradas
    const [highlightedIndexOriTrasNima, setHighlightedIndexOriTrasNima] = useState(-1); // Índice de la opción resaltada 
       
    // Debounce helper
    const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef(null);
    return useCallback((...args) => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
        callback(...args);
        }, delay);
    }, [callback, delay]);
    };
    
    // Dentro del componente
    const debouncedHandleSearchPostalCode= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredpostalCodeOriTras([]);
            setHighlightedIndexPostalCodeOriTras(-1);
        return;
        }
        const filtered = postalCodeOriTrasToSelect
        .filter(postal => postal && postal.postalcode)
        .filter(postal => {
            const postalcode = postal.postalcode.toUpperCase();
            return postalcode.startsWith(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredpostalCodeOriTras(filtered);
        setHighlightedIndexPostalCodeOriTras(0);
    }, 300); 
    const handleSelectPostalCodeOriTras = (postal) => {
        if (!postal) return; // Validación adicional para evitar errores
        setFormContract((formContract) => ({
            ...formContract,
            ori_tras_postalcode_id: postal.id || Number(DEFAULTPOSTALCODE_ID),
            ori_tras_postalcode_code: postal.postalcode ||  DEFAULTPOSTALCODE_CODE,
            ori_tras_postalcode_name: postal.name || DEFAULTPOSTALCODE_NAME,
            ori_tras_province_id: postal.province_id || Number(DEFAULTPROVINCE)
        }));
        setFilteredpostalCodeOriTras([]);
        setHighlightedIndexPostalCodeOriTras(-1);
    }; 
    const handleKeyDownDPostalCodeOriTras = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredpostalCodeOriTras.length === 0 && formContract.ori_tras_postalcode_code.trim() === "") {
            setHighlightedIndexPostalCodeOriTras(postalCodeOriTrasToSelect);
            setHighlightedIndexPostalCodeOriTras(0);
        } else {
            setHighlightedIndexPostalCodeOriTras((prevIndex) => {
            const nextIndex = prevIndex < filteredpostalCodeOriTras.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexPostalCodeOriTras((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexPostalCodeOriTras >= 0) {
            if (highlightedIndexPostalCodeOriTras >= 0 && highlightedIndexPostalCodeOriTras < filteredpostalCodeOriTras.length) {
                handleSelectPostalCodeOriTras(filteredpostalCodeOriTras[highlightedIndexPostalCodeOriTras]);
            }
        } else if (event.key === "Escape") {
            const isValid = postalCodeOriTrasToSelect.some((postal) => {
                if (!postal || !postal.postalcode) return false; 
                const normalizedPostalCodeId = postal.postalcode.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formContract.ori_tras_postalcode_code.toUpperCase();
                return normalizedPostalCodeId === normalizedInputId;
            }); 
        if (!isValid) { 
            setFormContract((formContract) => ({
                ...formContract,
                ori_tras_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
                ori_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
                ori_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
                ori_tras_province_id: Number(DEFAULTPROVINCE)
            }));
        } 
        setFilteredpostalCodeOriTras([]);
        setHighlightedIndexPostalCodeOriTras(-1);
        }
    };
    // Dentro del componente
    const debouncedHandleSearchPostalCodeFiscal= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredpostalCodeOriTrasFiscal([]);
            setHighlightedIndexPostalCodeOriTrasFiscal(-1);
        return;
        }
        const filtered = postalCodeOriTrasFiscalToSelect
        .filter(postal => postal && postal.postalcode)
        .filter(postal => {
            const postalcode = postal.postalcode.toUpperCase();
            return postalcode.startsWith(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredpostalCodeOriTrasFiscal(filtered);
        setHighlightedIndexPostalCodeOriTrasFiscal(0);
    }, 300); 

    const handleSelectPostalCodeOriTrasFiscal = (postal) => {
        if (!postal) return; // Validación adicional para evitar errores
        setFormContract((formContract) => ({
            ...formContract,
            ori_tras_postalcode_id_fiscal: postal.id || Number(DEFAULTPOSTALCODE_ID),
            ori_tras_postalcode_code_fiscal: postal.postalcode ||  DEFAULTPOSTALCODE_CODE,
            ori_tras_postalcode_name_fiscal: postal.name || DEFAULTPOSTALCODE_NAME,
            ori_tras_province_id_fiscal: postal.province_id || Number(DEFAULTPROVINCE)
        }));
        setFilteredpostalCodeOriTrasFiscal([]);
        setHighlightedIndexPostalCodeOriTrasFiscal(-1);
    };
    const handleKeyDownDPostalCodeOriTrasFiscal = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredpostalCodeOriTrasFiscal.length === 0 && formContract.ori_tras_postalcode_code_fiscal.trim() === "") {
            setHighlightedIndexPostalCodeOriTrasFiscal(postalCodeOriTrasFiscalToSelect);
            setHighlightedIndexPostalCodeOriTrasFiscal(0);
        } else {
            setHighlightedIndexPostalCodeOriTrasFiscal((prevIndex) => {
            const nextIndex = prevIndex < filteredpostalCodeOriTrasFiscal.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexPostalCodeOriTrasFiscal((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexPostalCodeOriTrasFiscal >= 0) {
            if (highlightedIndexPostalCodeOriTrasFiscal >= 0 && highlightedIndexPostalCodeOriTrasFiscal < filteredpostalCodeOriTrasFiscal.length) {
                handleSelectPostalCodeOriTrasFiscal(filteredpostalCodeOriTrasFiscal[highlightedIndexPostalCodeOriTrasFiscal]);
            }
        } else if (event.key === "Escape") {
            const isValid = postalCodeOriTrasFiscalToSelect.some((postal) => {
                if (!postal || !postal.postalcode) return false; 
                const normalizedPostalCodeId = postal.postalcode.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formContract.ori_tras_postalcode_code_fiscal.toUpperCase();
                return normalizedPostalCodeId === normalizedInputId;
            }); 
        if (!isValid) { 
            setFormContract((formContract) => ({
                ...formContract,
                ori_tras_postalcode_id_fiscal:  Number(DEFAULTPOSTALCODE_ID),
                ori_tras_postalcode_code_fiscal:  DEFAULTPOSTALCODE_CODE,
                ori_tras_postalcode_name_fiscal: DEFAULTPOSTALCODE_NAME,
                ori_tras_province_id_fiscal: Number(DEFAULTPROVINCE)
            }));
        } 
        setFilteredpostalCodeOriTrasFiscal([]);
        setHighlightedIndexPostalCodeOriTrasFiscal(-1);
        }
    };

    // Dentro del componente
    const debouncedHandleSearchDocumentId = useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredDocumentIdOriTras([]);
            setHighlightedIndexDocumentIdOriTras(-1);
            return;
        }
        const filtered = documentIdOriTrasToSelect
            .filter(store => store && store.documentid)
            .filter(store => {
            const documentid = store.documentid.toUpperCase();
            return documentid.includes(upperValue);
            })
            .slice(0, 20); // limitar resultados
        setFilteredDocumentIdOriTras(filtered);
        setHighlightedIndexDocumentIdOriTras(0);
    }, 300);
    const handleSelectDocumentIdOri = (store) => {
        if (!store) return; // Validación adicional para evitar errores
        setFormContract((formContract) => ({
            ...formContract,
            ori_tras_documentid: store.documentid || "",
        }));
        setFilteredDocumentIdOriTras([]);
        setHighlightedIndexDocumentIdOriTras(-1);
    }; 
    const handleKeyDownDocumentIdOriTras = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredDocumentIdOriTras.length === 0 && formContract.ori_tras_documentid.trim() === "") {
            setFilteredDocumentIdOriTras(documentIdOriTrasToSelect);
            setHighlightedIndexDocumentIdOriTras(0);
        } else {
            setHighlightedIndexDocumentIdOriTras((prevIndex) => {
            const nextIndex = prevIndex < filteredDocumentIdOriTras.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexDocumentIdOriTras((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexDocumentIdOriTras >= 0) {
        if (highlightedIndexDocumentIdOriTras >= 0 && highlightedIndexDocumentIdOriTras < filteredDocumentIdOriTras.length) {
            handleSelectDocumentIdOri(filteredDocumentIdOriTras[highlightedIndexDocumentIdOriTras]);
        }
        } else if (event.key === "Escape") {
            const isValid = documentIdOriTrasToSelect.some((store) => {
                if (!store || !store.documentid) return false; 
                const normalizedStoreId = store.documentid.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formContract.ori_tras_documentid.toUpperCase();
                return normalizedStoreId === normalizedInputId;
            }); 
        if (!isValid) {
            setFormContract((formContract) => ({
            ...formContract,
            ori_tras_documentid: "",
            }));
        } 
        setFilteredDocumentIdOriTras([]);
        setHighlightedIndexDocumentIdOriTras(-1);
        }
    };
    // Dentro del componente
    const debouncedHandleSearchTradename= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredTradenamedOriTras([]);
            setHighlightedIndexTradenamedOriTras(-1);
        return;
        }
        const filtered = tradenameOriTrasToSelect
        .filter(store => store && store.tradename)
        .filter(store => {
            const tradename = store.tradename.toUpperCase();
            return tradename.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredTradenamedOriTras(filtered);
        setHighlightedIndexTradenamedOriTras(0);
    }, 300); 
    const handleSelectTradeNameOriTras = (store) => {
        if (!store) return; // Validación adicional para evitar errores
        setFormContract((formContract) => ({
        ...formContract,
        ori_tras_tradename: store.tradename || "",
        ori_tras_documentid: store.documentid || formContract.ori_tras_documentid,
        
        }));
        setFilteredTradenamedOriTras([]);
        setHighlightedIndexTradenamedOriTras(-1);
    }; 
    const handleKeyDownTradenameOriTras = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredTradenamedOriTras.length === 0 && formContract.ori_tras_tradename.trim() === "") {
            setFilteredTradenamedOriTras(tradenameOriTrasToSelect);
            setHighlightedIndexTradenamedOriTras(0);
        } else {
            setHighlightedIndexTradenamedOriTras((prevIndex) => {
            const nextIndex = prevIndex < filteredTradenamedOriTras.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
        setHighlightedIndexTradenamedOriTras((prevIndex) => {
            const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
            // Desplaza al elemento anterior
            scrollToElement(prevIndexValid);
            return prevIndexValid;
        });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexTradenamedOriTras >= 0) {
        if (highlightedIndexTradenamedOriTras >= 0 && highlightedIndexTradenamedOriTras < filteredTradenamedOriTras.length) {
            handleSelectTradeNameOriTras(filteredTradenamedOriTras[highlightedIndexTradenamedOriTras]);
        }
        } else if (event.key === "Escape") {
        const isValid = tradenameOriTrasToSelect.some((store) => {
            if (!store || !store.tradename) return false; 
            const normalizedTradeName = store.tradename.toUpperCase();
            const normalizedInputTradeName = formContract.ori_tras_tradename.toUpperCase();
            return normalizedTradeName === normalizedInputTradeName;
        }); 
        if (!isValid) {
            setFormContract((formContract) => ({
            ...formContract,
            ori_tras_tradename: "",
            }));
        } 
        setFilteredTradenamedOriTras([]);
        setHighlightedIndexTradenamedOriTras(-1);
        }
    }; 

    // Dentro del componente
    const debouncedHandleSearchOriTrasNima= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredOriTrasNima([]);
            setHighlightedIndexOriTrasNima(-1);
        return;
        }
        const filtered = oriTrasNimaToSelect
        .filter(nt => nt && nt.nima)
        .filter(nt => {
            const nima = nt.nima.toUpperCase();
            return nima.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredOriTrasNima(filtered);
        setHighlightedIndexOriTrasNima(0);
    }, 300); 
    const handleSelectOriTrasNima = (nt) => {
        if (!nt) return; // Validación adicional para evitar errores
        setFormContract((formContract) => ({
        ...formContract,
        ori_tras_nima: nt.nima || ""
        }));
        setFilteredOriTrasNima([]);
        setHighlightedIndexOriTrasNima(-1);
    }; 
    const handleKeyDownOriTrasNima = (event) => {
       if (event.key === "ArrowDown") {
            if (filteredOriTrasNima.length === 0 && formContract.ori_tras_nima.trim() === "") {
                const filtered = oriTrasNimaToSelect.filter(nt => nt && nt.nima).slice(0, 20);
                setFilteredOriTrasNima(filtered);
                setHighlightedIndexOriTrasNima(0);
            } else {
                setHighlightedIndexOriTrasNima((prevIndex) => {
                    const nextIndex = prevIndex < filteredOriTrasNima.length - 1 ? prevIndex + 1 : prevIndex;
                    scrollToElement(nextIndex);
                    return nextIndex;
                });
            }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexOriTrasNima((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexOriTrasNima >= 0) {
            if (highlightedIndexOriTrasNima >= 0 && highlightedIndexOriTrasNima < filteredOriTrasNima.length) {
                handleSelectOriTrasNima(filteredOriTrasNima[highlightedIndexOriTrasNima]);
            }
        } else if (event.key === "Escape") {
            const isValid = oriTrasNimaToSelect.some((nt) => {
                if (!nt || !nt.nima) return false; 
                const normalizedPostalCodeId = nt.nima.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formContract.ori_tras_nima.toUpperCase();
                return normalizedPostalCodeId === normalizedInputId;
            }); 
        if (!isValid) { 
            setFormContract((formContract) => ({
                ...formContract, 
                ori_tras_nima: ""
            }));
        } 
        setFilteredOriTrasNima([]);
        setHighlightedIndexOriTrasNima(-1);
        }
    };

    // Función para desplazar el contenedor
    const scrollToElement = (index) => {
        const dropdown = document.querySelector(".dropdown-class"); // Cambia por tu clase/ID
        const item = dropdown?.children[index];
        if (item) {
        item.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
        });
        }
    };

    const handleBlur = useCallback((event) => {
            if (!event || !event.currentTarget) return;
        // Asegúrate de que no se cierra si haces clic en un elemento de la lista
        if (!event.currentTarget.contains(event.relatedTarget)) {
            setFilteredpostalCodeOriTras([]);
            setHighlightedIndexPostalCodeOriTras(-1);
            setFilteredpostalCodeOriTrasFiscal([]);
            setHighlightedIndexPostalCodeOriTrasFiscal(-1);
            setFilteredDocumentIdOriTras([]);
            setHighlightedIndexDocumentIdOriTras(-1);
            setFilteredTradenamedOriTras([]);
            setHighlightedIndexTradenamedOriTras(-1); 
            setFilteredOriTrasNima([]);
            setHighlightedIndexOriTrasNima(-1);   
        }
    }, []);

    const handleChangeSelectDocumentType_Ori_Tras = (event) => {
        setFormContract(formContract => ({
            ...formContract,
            ori_tras_documnettype_id:event.target.value
        }));
    };

    const handleBlurSelectDocumentType_Ori_Tras = (e) => {
        handleChangeSelectDocumentType_Ori_Tras(e);
    };

    const handleChangeSelectRoadType_Ori_Tras = (event) => {
        setFormContract(formContract => ({
            ...formContract,
            ori_tras_roadtype_id : event.target.value 
        }));
    };

    const handleBlurSelectRoadType_Ori_Tras = (e) => {
        handleChangeSelectRoadType_Ori_Tras(e);
        setErrorsForm(validateFormContract());
    };

     const handleChangeSelectRoadTypeFiscal_Ori_Tras = (event) => {
        setFormContract(formContract => ({
            ...formContract,
            ori_tras_roadtype_id_fiscal : event.target.value 
        }));
    };

    const handleBlurSelectRoadType_Fiscal_Ori_Tras = (e) => {
        handleChangeSelectRoadTypeFiscal_Ori_Tras(e);
        setErrorsForm(validateFormContract());
    };

    const handleChangeSelectCommunity_Ori_Tras = (event) => {
        setFormContract(formContract => ({
            ...formContract,
            ori_tras_community_id : event.target.value   
        }));
    };

    const handleBlurSelectCommunity_Ori_Tras = (e) => {
        handleChangeSelectCommunity_Ori_Tras(e);
        setErrorsForm(validateFormContract());
    };

    const handleChangeSelectCommunityFiscal_Ori_Tras = (event) => {
        setFormContract(formContract => ({
            ...formContract,
            ori_tras_community_id_fiscal : event.target.value   
        }));
    };

    const handleBlurSelectCommunityFiscal_Ori_Tras = (e) => {
        handleChangeSelectCommunityFiscal_Ori_Tras(e);
        setErrorsForm(validateFormContract());
    };
    
    const handleChangeSelectDocumentTypeEmployee_Ori_Tras = (event) => {
        setFormContract(formContract => ({
            ...formContract,
            ori_tras_contactname_documnettype_id:event.target.value
        }));
    };

    const handleBlurSelectDocumentTypeEmployee_Ori_Tras = (e) => {
        handleChangeSelectDocumentTypeEmployee_Ori_Tras(e);
    };
     
 
    const handleChangeDataEditContract_Ori_Tras = (e) => {
        const { name, value } = e.target;
        setFormContract(formContract => ({
          ...formContract,
          [name]: value,
        }));
    };

    const handleBlurDataEditContract_Ori_Tras = (e) => {
        handleChangeDataEditContract_Ori_Tras(e);
        setErrorsForm(validateFormContract());
    };
    
    const searchFormStore = (event) => {
        setShowModalSearchStores(true);
    };

    const searchFormEmployee = (event) => {
        setShowModalSearchEmployees(true);
    };

    const searchFormStoreAddress = (event) => {
        setPriority(2);
        setTetxtSearch("Ori_Tras");
        setShowModalSearchStoresAddress(true);
    };

    const searchFormStoreAddressFiscal = (event) => {
        setPriority(-1);
        setTetxtSearch("Ori_Tras_Fiscal")
        setShowModalSearchStoresAddress(true);
    };

     const searchFormStoreNimaAddress = (event) => {
        setPriority(2);
        setTetxtSearch("Ori_Tras");
        setShowModalSearchStoresNimaAddress(true);
    };

    const deleteDateOriTras = (event) => {
      setFormContract(formContract => ({
          ...formContract,
            ori_tras_store_id:0,
            ori_tras_documnettype_id: Number(DEFAULTTYPEOFDOCUMENT),
            ori_tras_documentid:"",
            ori_tras_tradename: "",
            ori_tras_name: "",
            ori_tras_contactname: "",
            ori_tras_contactname_employee_id: 0,
            ori_tras_contactname_documnettype_id: "",
            ori_tras_contactname_documentid: "",
            ori_tras_contactname_firstaname: "",
            ori_tras_contactname_lastname1: "",
            ori_tras_contactname_lastname2: "",
            ori_tras_contactname_position: "",
            ori_tras_contactname_email: "",
            ori_tras_contactname_phone: "",
            ori_tras_nima: "",
            ori_tras_inscription: "",
            ori_tras_grnp:"",
            ori_tras_opt: 0,
            ori_tras_phone: "",
            ori_tras_email: "",
            ori_tras_roadtype_id: Number(DEFAULTROADTYE),
            ori_tras_street: "",
            ori_tras_country_id: Number(DEFAULTCOUNTRY),
            ori_tras_country_name:DEFAULTCOUNTRY_NAME,
            ori_tras_province_id: Number(DEFAULTPROVINCE),
            ori_tras_province_name:DEFAULTPROVINCE_NAME,
            ori_tras_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
            ori_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
            ori_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
            ori_tras_community_id: Number(DEFAULTCOMMUNITY),
            ori_tras_community_name: DEFAULTCOMMUNITY_NAME, 
            ori_tras_roadtype_id_fiscal: Number(DEFAULTROADTYE),
            ori_tras_street_fiscal: "",
            ori_tras_country_id_fiscal: Number(DEFAULTCOUNTRY),
            ori_tras_country_name_fiscal:DEFAULTCOUNTRY_NAME,
            ori_tras_province_id_fiscal: Number(DEFAULTPROVINCE),
            ori_tras_province_name_fiscal:DEFAULTPROVINCE_NAME,
            ori_tras_postalcode_id_fiscal:  Number(DEFAULTPOSTALCODE_ID),
            ori_tras_postalcode_code_fiscal:  DEFAULTPOSTALCODE_CODE,
            ori_tras_postalcode_name_fiscal: DEFAULTPOSTALCODE_NAME,
            ori_tras_community_id_fiscal: Number(DEFAULTCOMMUNITY),
            ori_tras_community_name_fiscal: DEFAULTCOMMUNITY_NAME      
        }));
        setErrorsForm(validateFormContract());
        setErrorsForm(errorsForm => ({
            ...errorsForm,
            ori_tras_store_id:"",
            ori_tras_documnettype_id: "",
            ori_tras_documentid:"",
            ori_tras_tradename: "",
            ori_tras_name: "",
            ori_tras_contactname: "",
            ori_tras_contactname_employee_id : "",
            ori_tras_contactname_documnettype_id : "",
            ori_tras_contactname_documentid : "",
            ori_tras_contactname_firstaname : "",
            ori_tras_contactname_lastname1 : "",
            ori_tras_contactname_lastname2 : "",
            ori_tras_contactname_position : "",
            ori_tras_contactname_email : "",
            ori_tras_contactname_phone : "", 
            ori_tras_nima: "",
            ori_tras_inscription: "",
            ori_tras_grnp:"",
            ori_tras_opt: 0,
            ori_tras_phone: "",
            ori_tras_email: "",
            ori_tras_roadtype_id: "",
            ori_tras_street: "",
            ori_tras_country_id: "",
            ori_tras_country_name:"",
            ori_tras_province_id: "",
            ori_tras_province_name: "",
            ori_tras_postalcode_id: "",
            ori_tras_postalcode_code: "",
            ori_tras_postalcode_name: "",
            ori_tras_community_id: "",
            ori_tras_community_name:"",
            ori_tras_roadtype_id_fiscal: "",
            ori_tras_street_fiscal: "",
            ori_tras_country_id_fiscal: "",
            ori_tras_country_name_fiscal:"",
            ori_tras_province_id_fiscal: "",
            ori_tras_province_name_fiscal:"",
            ori_tras_postalcode_id_fiscal: "",
            ori_tras_postalcode_code_fiscal: "",
            ori_tras_postalcode_name_fiscal:"",
            ori_tras_community_id_fiscal: "",
            ori_tras_community_name_fiscal:""
        }));
        setErrorsForm(errorsForm => ({
            ...errorsForm,
            ori_tras_documentid: 'Text_FieldDateOriTrasDocumentIDRequired'
        })); 
    };

    const deleteDataSteetOriTras = (event) => {
        setFormContract(formContract => ({
          ...formContract,
            ori_tras_roadtype_id: Number(DEFAULTROADTYE),
            ori_tras_street: "",
            ori_tras_country_id: Number(DEFAULTCOUNTRY),
            ori_tras_country_name:DEFAULTCOUNTRY_NAME,
            ori_tras_province_id: Number(DEFAULTPROVINCE),
            ori_tras_province_name:DEFAULTPROVINCE_NAME,
            ori_tras_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
            ori_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
            ori_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
            ori_tras_community_id: Number(DEFAULTCOMMUNITY),
            ori_tras_community_name: DEFAULTCOMMUNITY_NAME, 
            ori_tras_nima: "",
            ori_tras_inscription: "",
            ori_tras_grnp:"",
            ori_tras_opt: 0
        }));
        setErrorsForm(validateFormContract());
    };

    const deleteDataStreetFiscalOriTras = (event) => {
        setFormContract(formContract => ({
          ...formContract,
            ori_tras_roadtype_id_fiscal: Number(DEFAULTROADTYE),
            ori_tras_country_id_fiscal: Number(DEFAULTCOUNTRY),
            ori_tras_street_fiscal: "",
            ori_tras_country_name_fiscal:DEFAULTCOUNTRY_NAME,
            ori_tras_province_id_fiscal: Number(DEFAULTPROVINCE),
            ori_tras_province_name_fiscal:DEFAULTPROVINCE_NAME,
            ori_tras_postalcode_id_fiscal:  Number(DEFAULTPOSTALCODE_ID),
            ori_tras_postalcode_code_fiscal:  DEFAULTPOSTALCODE_CODE,
            ori_tras_postalcode_name_fiscal: DEFAULTPOSTALCODE_NAME,
            ori_tras_community_id_fiscal: Number(DEFAULTCOMMUNITY),
            ori_tras_community_name_fiscal: DEFAULTCOMMUNITY_NAME
        }));
        setErrorsForm(validateFormContract());
    };

    const deleteDateEmployeeOriTras = (event) => {
        setFormContract(formContract => ({
          ...formContract,
            ori_tras_contactname_employee_id: 0,
            ori_tras_contactname_documnettype_id: "",
            ori_tras_contactname_documentid: "",
            ori_tras_contactname_firstaname: "",
            ori_tras_contactname_lastname1: "",
            ori_tras_contactname_lastname2: "",
            ori_tras_contactname_position: "",
            ori_tras_contactname_email: "",
            ori_tras_contactname_phone: ""
        }));
        setErrorsForm(validateFormContract());
    }; 

    useEffect(() => {
        let isMounted = true;
        const fetchExistNumberDocument = async () => {
            try {
              const getData = await helpHttp().get2(ENDPOINT,`contract/getexiststorebynumberdocument/`,token,formContract.ori_tras_documentid.replace(/[.\-/\\|]/g, "").trim());
              if (getData.err) {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
              } else if (isMounted) {
                if (getData>0 && getData!==formContract.ori_tras_store_id){
                    fetchStoreNumberDocument();
                }
              }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };
 
        const fetchStoreNumberDocument = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`contract/getcontractstorebynumberdocument/`,token,formContract.ori_tras_documentid.replace(/[.\-/\\|]/g, ""));
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    if (getData!==undefined && getData!==null && getData!==""){
                        setFormContract(formContract => ({
                            ...formContract,
                            ori_tras_store_id: getData.store_id,
                            ori_tras_documnettype_id: (getData.documnettype_id===undefined 
                                                    || getData.documnettype_id===null  
                                                    || getData.documnettype_id===""
                                                    || getData.documnettype_id==="0"
                                                    || getData.documnettype_id===0)?
                                                    Number(DEFAULTTYPEOFDOCUMENT):getData.documnettype_id,
                            ori_tras_tradename: getData.tradename,
                            ori_tras_name: getData.name,
                            ori_tras_contactname: getData.contacname,
                            ori_tras_nima: getData.nima_ori_tras,
                            ori_tras_inscription: getData.pygr_ori_tras,
                            ori_tras_grnp:getData.grnp_ori_tras,
                            ori_tras_opt: getData.opt_ori_tras,
                            ori_tras_phone: getData.phone,
                            ori_tras_email: getData.email, 
                            ori_tras_roadtype_id: (getData.roadtype_id===undefined 
                                                    || getData.roadtype_id===null  
                                                    || getData.roadtype_id===""
                                                    || getData.roadtype_id==="0"
                                                    || getData.roadtype_id===0)?
                                                    Number(DEFAULTROADTYE):getData.roadtype_id,
                            ori_tras_street: getData.street,
                            ori_tras_country_id: (getData.country_id===undefined 
                                                    || getData.country_id===null  
                                                    || getData.country_id===""
                                                    || getData.country_id==="0"
                                                    || getData.country_id===0)?
                                                    Number(DEFAULTCOUNTRY):getData.country_id,
                            ori_tras_country_name: (getData.country_name===undefined 
                                                    || getData.country_name===null  
                                                    || getData.country_name==="" )?
                                                    DEFAULTCOUNTRY_NAME:getData.country_name,
                            ori_tras_province_id: (getData.province_id===undefined 
                                                    || getData.province_id===null  
                                                    || getData.province_id===""
                                                    || getData.province_id==="0"
                                                    || getData.province_id===0)?
                                                    Number(DEFAULTPROVINCE):getData.province_id,
                            ori_tras_province_name: (getData.province_name===undefined 
                                                    || getData.province_name===null  
                                                    || getData.province_name==="" )?
                                                    DEFAULTPROVINCE_NAME:getData.province_name, 
                            ori_tras_postalcode_id: (getData.postalcode_id===undefined 
                                                        || getData.postalcode_id===null  
                                                        || getData.postalcode_id===""
                                                        || getData.postalcode_id==="0"
                                                        || getData.postalcode_id===0)?
                                                        Number(DEFAULTPOSTALCODE_ID):getData.postalcode_id,
                            ori_tras_postalcode_code: (getData.postalcode_code===undefined 
                                                        || getData.postalcode_code===null  
                                                        || getData.postalcode_code==="" )?
                                                         DEFAULTPOSTALCODE_CODE:getData.postalcode_code,
                            ori_tras_postalcode_name:   (getData.postalcode_name===undefined 
                                                        || getData.postalcode_name===null  
                                                        || getData.postalcode_name==="" )?
                                                         DEFAULTPOSTALCODE_NAME:getData.postalcode_name,                       
                            ori_tras_community_id: (getData.community_id===undefined 
                                                        || getData.community_id===null  
                                                        || getData.community_id===""
                                                        || getData.community_id==="0"
                                                        || getData.community_id===0)?
                                                        Number(DEFAULTCOMMUNITY):getData.community_id,
                            ori_tras_community_name:   (getData.community_name===undefined 
                                                        || getData.community_name===null  
                                                        || getData.community_name==="" )?
                                                         DEFAULTCOMMUNITY_NAME:getData.community_name,  
                            ori_tras_roadtype_id_fiscal: (getData.roadtype_id_fiscal===undefined 
                                                    || getData.roadtype_id_fiscal===null  
                                                    || getData.roadtype_id_fiscal===""
                                                    || getData.roadtype_id_fiscal==="0"
                                                    || getData.roadtype_id_fiscal===0)?
                                                    Number(DEFAULTROADTYE):getData.roadtype_id_fiscal,
                            ori_tras_street_fiscal: getData.street_fiscal,
                            ori_tras_country_id_fiscal: (getData.country_id_fiscal===undefined 
                                                    || getData.country_id_fiscal===null  
                                                    || getData.country_id_fiscal===""
                                                    || getData.country_id_fiscal==="0"
                                                    || getData.country_id_fiscal===0)?
                                                    Number(DEFAULTCOUNTRY):getData.country_id_fiscal,
                            ori_tras_country_name_fiscal: (getData.country_name_fiscal===undefined 
                                                    || getData.country_name_fiscal===null  
                                                    || getData.country_name_fiscal==="" )?
                                                    DEFAULTCOUNTRY_NAME:getData.country_name_fiscal,
                            ori_tras_province_id_fiscal: (getData.province_id_fiscal===undefined 
                                                    || getData.province_id_fiscal===null  
                                                    || getData.province_id_fiscal===""
                                                    || getData.province_id_fiscal==="0"
                                                    || getData.province_id_fiscal===0)?
                                                    Number(DEFAULTPROVINCE):getData.province_id_fiscal,
                            ori_tras_province_name_fiscal: (getData.province_name_fiscal===undefined 
                                                    || getData.province_name_fiscal===null  
                                                    || getData.province_name_fiscal==="" )?
                                                    DEFAULTPROVINCE_NAME:getData.province_name_fiscal, 
                            ori_tras_postalcode_id_fiscal: (getData.postalcode_id_fiscal===undefined 
                                                        || getData.postalcode_id_fiscal===null  
                                                        || getData.postalcode_id_fiscal===""
                                                        || getData.postalcode_id_fiscal==="0"
                                                        || getData.postalcodpostalcode_id_fiscal_id===0)?
                                                        Number(DEFAULTPOSTALCODE_ID):getData.postalcode_id_fiscal,
                            ori_tras_postalcode_code_fiscal: (getData.postalcode_code_fiscal===undefined 
                                                        || getData.postalcode_code_fiscal===null  
                                                        || getData.postalcode_code_fiscal==="" )?
                                                         DEFAULTPOSTALCODE_CODE:getData.postalcode_code_fiscal,
                            ori_tras_postalcode_name_fiscal:   (getData.postalcode_name_fiscal===undefined 
                                                        || getData.postalcode_name_fiscal===null  
                                                        || getData.postalcode_name_fiscal==="" )?
                                                         DEFAULTPOSTALCODE_NAME:getData.postalcode_name_fiscal,                       
                            ori_tras_community_id_fiscal: (getData.community_id_fiscal===undefined 
                                                        || getData.community_id_fiscal===null  
                                                        || getData.community_id_fiscal===""
                                                        || getData.community_id_fiscal==="0"
                                                        || getData.community_id_fiscal===0)?
                                                        Number(DEFAULTCOMMUNITY):getData.community_id_fiscal,
                            ori_tras_community_name_fiscal:   (getData.community_name_fiscal===undefined 
                                                        || getData.community_name_fiscal===null  
                                                        || getData.community_name_fiscal==="" )?
                                                         DEFAULTCOMMUNITY_NAME:getData.community_name_fiscal
                        }));
                        setErrorsForm(validateFormContract());
                    }  
                }         
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };

        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel2'){
            if (formContract.ori_tras_documentid && formContract.ori_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!==""){
                fetchExistNumberDocument();
            }  
        }
        return () => { isMounted = false };
    }, [t,token,dispatch,expanded,formContract.ori_tras_documentid,errorsForm.ori_tras_documentid,setIsLoadingErrorData,DEFAULTCOMMUNITY,DEFAULTCOUNTRY,setFormContract,formContract.ori_tras_store_id,setErrorsForm,validateFormContract,DEFAULTPROVINCE,
        DEFAULTCOMMUNITY_NAME,DEFAULTCOUNTRY_NAME,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPOSTALCODE_NAME,DEFAULTPROVINCE_NAME,DEFAULTROADTYE,DEFAULTTYPEOFDOCUMENT
    ]);
    
    useEffect(() => {
        let isMounted = true; 
        const fetchDataDocumentIdOri = async () => {
          try {
            const getData = await helpHttp().get2(ENDPOINT,`contract/getlistdocumentidcontracts/`,token,
              (formContract.ori_tras_documentid!==undefined && formContract.ori_tras_documentid!==null && formContract.ori_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="")?formContract.ori_tras_documentid.replace(/[.\-/\\|]/g, "").trim():"-1"); 
            if (getData.err) {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            } else if (isMounted) {
              setDocumentIdOriTrasToSelect(getData); 
            }
          } catch (error) {
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
          }
        };   
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel2'){
            if (formContract.ori_tras_documentid && formContract.ori_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataDocumentIdOri();
            }
        } else{
            setDocumentIdOriTrasToSelect(initialDocumentIdToSelect);
        } 
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formContract.ori_tras_documentid,expanded]);

     useEffect(() => {
        let isMounted = true;
        const fetchExistNumberDocumentEmployee = async () => {
            try {
              const getData = await helpHttp().get2(ENDPOINT,`contract/getexistemployeebynumberdocument/`,token,formContract.ori_tras_contactname_documentid);
              if (getData.err) {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
              } else if (isMounted) {
                if (getData>0 && getData!==formContract.ori_tras_contactname_documentid){
                    fetchStoreNumberDocumentEmpoyee();
                }
              }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };
 
        const fetchStoreNumberDocumentEmpoyee = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`contract/getempoyeebynumberdocument/`,token,formContract.ori_tras_contactname_documentid);
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    if (getData!==undefined && getData!==null && getData!==""){
                        setFormContract(formContract => ({
                            ...formContract,
                            ori_tras_contactname_employee_id: getData.id,
                            ori_tras_contactname_documnettype_id: (getData.documnettype_id===undefined 
                                                    || getData.documnettype_id===null  
                                                    || getData.documnettype_id===""
                                                    || getData.documnettype_id==="0"
                                                    || getData.documnettype_id===0)?
                                                    2:getData.documnettype_id,
                            ori_tras_contactname_firstaname: getData.firstname,
                            ori_tras_contactname_lastname1: getData.lastname1,
                            ori_tras_contactname_lastname2: getData.lastname2,
                            ori_tras_contactname_email: getData.email,
                            ori_tras_contactname_phone: getData.phone
                        }));
                    }  
                }         
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel2'){
            if (formContract.ori_tras_contactname_documentid!==""){
                fetchExistNumberDocumentEmployee();
            }
        }
        return () => { isMounted = false };
    }, [t,token,dispatch,expanded,formContract.ori_tras_contactname_documentid,errorsForm.ori_tras_contactname_documentid,setIsLoadingErrorData,DEFAULTCOMMUNITY,DEFAULTCOUNTRY,setFormContract,formContract.ori_tras_contactname_employee_id]);
    

    
    useEffect(() => {
        let isMounted = true; 
        const fetchDataTradenameOri = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`contract/getlisttradenamecontracts/`,token,
                    (formContract.ori_tras_tradename!==undefined && formContract.ori_tras_tradename!==null && formContract.ori_tras_tradename.replace(/[.\-/\\|]/g, "").trim()!=="")?formContract.ori_tras_tradename.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setTradenameOriTrasToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel2'){
            if (formContract.ori_tras_tradename && formContract.ori_tras_tradename.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataTradenameOri();
            }
        } else{
            setTradenameOriTrasToSelect(initialDocumentIdToSelect);
        }  
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formContract.ori_tras_tradename,expanded]);
    
    useEffect(() => {
        let isMounted = true; 
        const fetchDataPostalCodeOri = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`contract/getlistpostalcodect/`,token,
                    (formContract.ori_tras_postalcode_code!==undefined && formContract.ori_tras_postalcode_code!==null && formContract.ori_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim()!=="")?formContract.ori_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setPostalCodeOriTrasToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData')));  
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel2'){
            if (formContract.ori_tras_postalcode_code && formContract.ori_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataPostalCodeOri();
            } 
        } else{
            setPostalCodeOriTrasToSelect(initialPostalCodesToSelect);
        }  
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formContract.ori_tras_postalcode_code,expanded,DEFAULTPROVINCE,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPROVINCE_NAME,setFormContract]);
    
     useEffect(() => {
        let isMounted = true; 
        const fetchDataPostalCodeOriFiscal = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`contract/getlistpostalcodect/`,token,
                    (formContract.ori_tras_postalcode_code_fiscal!==undefined && formContract.ori_tras_postalcode_code_fiscal!==null && formContract.ori_tras_postalcode_code_fiscal.replace(/[.\-/\\|]/g, "").trim()!=="")?formContract.ori_tras_postalcode_code_fiscal.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setPostalCodeOriTrasFiscalToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData')));  
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel2'){
            if (formContract.ori_tras_postalcode_code_fiscal && formContract.ori_tras_postalcode_code_fiscal.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataPostalCodeOriFiscal();
            } 
        } else{
            setPostalCodeOriTrasFiscalToSelect(initialPostalCodesToSelect);
        }  
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formContract.ori_tras_postalcode_code_fiscal,expanded,DEFAULTPROVINCE,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPROVINCE_NAME,setFormContract]);

     useEffect(() => {
        let isMounted = true; 
        const fetchDataNimaOriTras = async () => {
            try {
                const getData = await helpHttp().get5(ENDPOINT,`searchct/getlistnimas`,token,formContract.ori_tras_store_id, 
                    (formContract.ori_tras_nima!==undefined && formContract.ori_tras_nima!==null && formContract.ori_tras_nima.replace(/[.\-/\\|]/g, "").trim()!=="")?formContract.ori_tras_nima.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setOriTrasNimaToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData')));  
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel2'){
            if (formContract.ori_tras_store_id && formContract.ori_tras_store_id!==null && formContract.ori_tras_store_id!=="" && formContract.ori_tras_store_id!=="0" && formContract.ori_tras_store_id!==0){
                fetchDataNimaOriTras(); 
            }else{
                setOriTrasNimaToSelect(initialNimaToSelect);
            }
        }
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formContract,expanded,setFormContract,formContract.ori_tras_store_id]);
    
    return(
    (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel2') &&
        <>
            <div className="row p-2"> 
                <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_DocuentType')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="ori_tras_documnettype_id"
                        name="ori_tras_documnettype_id"
                        value={ (formContract.ori_tras_documnettype_id === undefined || formContract.ori_tras_documnettype_id ===null || formContract.ori_tras_documnettype_id ===""
                            || formContract.ori_tras_documnettype_id ==="0" || formContract.ori_tras_documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT):formContract.ori_tras_documnettype_id}
                        inputProps={{ style: {width: 200,  fontSize: '18px'}, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurSelectDocumentType_Ori_Tras}
                        onChange={handleChangeSelectDocumentType_Ori_Tras}
                        helperText={errorsForm.ori_tras_documnettype_id!=null && errorsForm.ori_tras_documnettype_id!==""?t(errorsForm.ori_tras_documnettype_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formContract.ori_tras_documnettype_id === undefined || formContract.ori_tras_documnettype_id ===null || formContract.ori_tras_documnettype_id ===""
                                || formContract.ori_tras_documnettype_id ==="0" || formContract.ori_tras_documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT): formContract.ori_tras_documnettype_id
                        }}>
                        <option key={0} value=""/>
                        {documentTypesToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {option.name}
                            </option>
                        ))}
                    </TextField>  
                    {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                    <label className="text-primary" style={{ fontSize: 18}}>{t('Text_CONTRACT_CIF')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;  
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="ori_tras_documentid"
                            name="ori_tras_documentid"
                            value={formContract.ori_tras_documentid}
                            onChange={(e) => {
                                setFormContract(prev => ({
                                ...prev,
                                ori_tras_documentid: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchDocumentId(e.target.value);
                            }}
                            onKeyDown={handleKeyDownDocumentIdOriTras}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                handleBlur();
                                }
                            }}
                            label={errorsForm.ori_tras_documentid!=null?t(errorsForm.ori_tras_documentid):t('PlaceHolder_CONTRACT_CIF')}
                            placeholder={t('PlaceHolder_CONTRACT_CIF')}
                            variant="standard"
                            inputProps={{ style: {width: i18n.language==='es'?283:323,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        />  
                        {/* Desplegable dinámico */}
                        {filteredDocumentIdOriTras.length > 0 && (
                            <div
                                className="dropdown-class"
                                style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                            borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                maxWidth: "400px",
                                overflowY: "auto",
                                width: "250%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredDocumentIdOriTras.map((store, index) => (
                                <MenuItem
                                    key={store.id}
                                    onClick={() => handleSelectDocumentIdOri(store)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexDocumentIdOriTras ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexDocumentIdOriTras ? "white" : "black",
                                    }}
                                >
                                    {store.documentid} - {store.tradename}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>  
                    &nbsp;&nbsp;
                    <IconButton  size="small" className="deletesmall-select-button"   onClick={deleteDateOriTras}>
                        <DeleteIcon style={{fontSize: 28}}/>
                    </IconButton>  
                    &nbsp;&nbsp;
                    {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores'))&&
                        <IconButton  size="small" className="edit-select-button" onClick={searchFormStore}>
                            <SearchIcon style={{fontSize: 28}}/>
                        </IconButton>
                    }
                </div>
                <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_TRADENAME')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="ori_tras_tradename"
                            name="ori_tras_tradename"
                            value={formContract.ori_tras_tradename}
                            onChange={(e) => {
                                setFormContract(prev => ({
                                    ...prev,
                                    ori_tras_tradename: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchTradename(e.target.value);
                            }}
                            onKeyDown={handleKeyDownTradenameOriTras}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                handleBlur();
                                }
                            }}
                            label={errorsForm.ori_tras_tradename!=null && errorsForm.ori_tras_tradename!==""?t(errorsForm.ori_tras_tradename):t('PlaceHolder_CONTRACT_TRADENAME')}
                            placeholder={t('PlaceHolder_CONTRACT_TRADENAME')}
                            variant="standard"
                            inputProps={{ style: {width: i18n.language==='es'?858:834,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        />  
                        {/* Desplegable dinámico */}
                        {filteredTradenamedOriTras.length > 0 && (
                            <div
                                className="dropdown-class"
                                style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                maxWidth: "800px",
                                overflowY: "auto",
                                width: "150%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredTradenamedOriTras.map((store, index) => (
                                <MenuItem
                                    key={store.id}
                                    onClick={() => handleSelectTradeNameOriTras(store)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexTradenamedOriTras ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexTradenamedOriTras ? "white" : "black",
                                    }}
                                >
                                    {store.tradename} - {store.documentid}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>
                </div>
                <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_NAME')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="ori_tras_name" 
                        name="ori_tras_name"
                        value={formContract.ori_tras_name}
                        inputProps={{ style: {width: i18n.language==='es'?812:857,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.ori_tras_name!=null && errorsForm.ori_tras_name!==""?t(errorsForm.ori_tras_name):t('PlaceHolder_CONTRACT_NAME')}
                        placeholder={t('PlaceHolder_CONTRACT_NAME')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Ori_Tras}
                        onChange={handleChangeDataEditContract_Ori_Tras} 
                    />
                </div>
                <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_CONTACT')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="ori_tras_contactname" 
                        name="ori_tras_contactname"
                        value={formContract.ori_tras_contactname}
                        inputProps={{ style: {width: i18n.language==='es'?795:840,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.ori_tras_contactname!=null && errorsForm.ori_tras_contactname!==""?t(errorsForm.ori_tras_contactname):t('PlaceHolder_CONTRACT_CONTACT')}
                        placeholder={t('PlaceHolder_CONTRACT_CONTACT')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Ori_Tras}
                        onChange={handleChangeDataEditContract_Ori_Tras} 
                    />
                </div>
            </div> 
            <Typography style={{color:"#067330", fontSize: 16}} >  
                {t('Text_CONTRACT_ADDRESS')}
            </Typography>
            <hr className="sidebar-divider d-none d-md-block"/>
            <div className="row p-2"> 
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_RoadType')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="ori_tras_roadtype"
                        name="ori_tras_roadtype"
                        value={ (formContract.ori_tras_roadtype_id === undefined || formContract.ori_tras_roadtype_id ===null || formContract.ori_tras_roadtype_id ===""
                            || formContract.ori_tras_roadtype_id ==="0" || formContract.ori_tras_roadtype_id ===0)?Number(DEFAULTROADTYE):formContract.ori_tras_roadtype_id}
                        inputProps={{ style: {width: i18n.language==='es'?150:150,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurSelectRoadType_Ori_Tras}
                        onChange={handleChangeSelectRoadType_Ori_Tras}
                        helperText={errorsForm.ori_tras_roadtype_id!=null && errorsForm.ori_tras_roadtype_id!==""?t(errorsForm.ori_tras_roadtype_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formContract.ori_tras_roadtype_id === undefined || formContract.ori_tras_roadtype_id ===null || formContract.ori_tras_roadtype_id ===""
                                || formContract.ori_tras_roadtype_id ==="0" || formContract.ori_tras_roadtype_id ===0)?Number(DEFAULTROADTYE): formContract.ori_tras_roadtype_id
                        }}>
                        <option key={0} value=""/>
                        {roadTypesToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {i18n.language==="es"?option.namees:option.nameen}
                            </option>
                        ))}
                    </TextField>  
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_ADDRESS')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="ori_tras_street" 
                        name="ori_tras_street"
                        value={formContract.ori_tras_street}
                        inputProps={{ style: {width: i18n.language==='es'?449:462,  fontSize: '18px', }, maxLength: 250 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.ori_tras_street!=null && errorsForm.ori_tras_street!==""?t(errorsForm.ori_tras_street):t('PlaceHolder_CONTRACT_ADDRESS')}
                        placeholder={t('PlaceHolder_CONTRACT_ADDRESS')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Ori_Tras}
                        onChange={handleChangeDataEditContract_Ori_Tras}
                    />
                </div>
                &nbsp;&nbsp;
                <IconButton  size="small" className="deletesmall-select-button" onClick={deleteDataSteetOriTras}>
                    <DeleteIcon style={{fontSize: 28}}/>
                </IconButton>  
                &nbsp;&nbsp;
                {(roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores')) && formContract.ori_tras_documentid!==undefined && formContract.ori_tras_documentid!=="") ?
                    <IconButton  size="small" className={`edit-${
                        (formContract.ori_tras_store_id===undefined
                        || formContract.ori_tras_store_id===""
                        || formContract.ori_tras_store_id==="0"
                        || formContract.ori_tras_store_id===0)
                        ? "noselect-button": "select-button" }`}
                        disabled={formContract.ori_tras_store_id===undefined
                        || formContract.ori_tras_store_id===""
                        || formContract.ori_tras_store_id==="0"
                        || formContract.ori_tras_store_id===0 }
                                onClick={searchFormStoreAddress}>
                    <SearchIcon style={{fontSize: 28}}/>
                    </IconButton>:
                    <IconButton  size="small" className="edit-noselect-button" disabled>
                        <SearchIcon style={{fontSize: 28}}/>
                    </IconButton> 
                }
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_PostalCode')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="ori_tras_postalcode_code"
                            name="ori_tras_postalcode_code"
                            value={formContract.ori_tras_postalcode_code}
                            onChange={(e) => {
                                    setFormContract(prev => ({
                                    ...prev,
                                    ori_tras_postalcode_code: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchPostalCode(e.target.value);
                            }}
                            onKeyDown={handleKeyDownDPostalCodeOriTras}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                    const inputPostalCode = formContract.ori_tras_postalcode_code.trim().toUpperCase();
                                    const matchedPostal = postalCodeOriTrasToSelect.find((postal) => {
                                    const normalizedPostal = postal.postalcode?.toUpperCase() || "";
                                    return normalizedPostal === inputPostalCode;
                                    });

                                    if (matchedPostal) {
                                        setFormContract((prev) => ({
                                            ...prev,
                                            ori_tras_postalcode_id: matchedPostal.id || Number(DEFAULTPOSTALCODE_ID),
                                            ori_tras_postalcode_code: matchedPostal.postalcode || DEFAULTPOSTALCODE_CODE,
                                            ori_tras_postalcode_name: matchedPostal.name || DEFAULTPOSTALCODE_NAME,
                                            ori_tras_province_id: matchedPostal.province_id || Number(DEFAULTPROVINCE),
                                        }));
                                    } else {
                                        setFormContract((prev) => ({
                                            ...prev,
                                            ori_tras_postalcode_id: Number(DEFAULTPOSTALCODE_ID),
                                            ori_tras_postalcode_code: DEFAULTPOSTALCODE_CODE,
                                            ori_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
                                            ori_tras_province_id: Number(DEFAULTPROVINCE),
                                        }));
                                    }
                                    setFilteredpostalCodeOriTras([]);
                                    setHighlightedIndexPostalCodeOriTras(-1);
                                }
                            }}
                            label={errorsForm.ori_tras_postalcode_code!=null && errorsForm.ori_tras_postalcode_code!==""?t(errorsForm.ori_tras_postalcode_code):t('Text_CONTRACT_PostalCode')}
                            placeholder={t('Text_CONTRACT_PostalCode')}
                            variant="standard"
                            inputProps={{ style: {width: i18n.language==='es'?100:100,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                        />  
                        {/* Desplegable dinámico */}
                        {filteredpostalCodeOriTras.length > 0 && (
                            <div
                                className="dropdown-class"
                                style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                overflowY: "auto",
                                width: "350%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredpostalCodeOriTras.map((postal, index) => (
                                <MenuItem
                                    key={postal.id}
                                    onClick={() => handleSelectPostalCodeOriTras(postal)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexPostalCodeOriTras ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexPostalCodeOriTras ? "white" : "black",
                                    }}
                                >
                                    {postal.postalcode} - {postal.name}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_Locality')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="ori_tras_postalcode_name" 
                        name="ori_tras_postalcode_name"
                        value={formContract.ori_tras_postalcode_name}
                        inputProps={{ style: {width: i18n.language==='es'?210:241,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.ori_tras_postalcode_name!=null && errorsForm.ori_tras_postalcode_name!==""?t(errorsForm.ori_tras_contactname):t('Text_CONTRACT_Locality')}
                        placeholder={t('Text_CONTRACT_Locality')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Ori_Tras}
                        onChange={handleChangeDataEditContract_Ori_Tras}
                        disabled
                    />  
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_Community')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="ori_tras_community_id"
                        name="ori_tras_community_id"
                        value={ (formContract.ori_tras_community_id === undefined || formContract.ori_tras_community_id ===null || formContract.ori_tras_community_id ===""
                            || formContract.ori_tras_community_id ==="0" || formContract.ori_tras_community_id ===0)?Number(DEFAULTCOMMUNITY):formContract.ori_tras_community_id}
                        inputProps={{ style: {width: i18n.language==='es'?200:200,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurSelectCommunity_Ori_Tras}
                        onChange={handleChangeSelectCommunity_Ori_Tras}
                        helperText={errorsForm.ori_tras_community_id!=null  && errorsForm.ori_tras_community_id!==""?t(errorsForm.ori_tras_community_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formContract.ori_tras_community_id === undefined || formContract.ori_tras_community_id ===null || formContract.ori_tras_community_id ===""
                                || formContract.ori_tras_community_id ==="0" || formContract.ori_tras_community_id ===0)?Number(DEFAULTCOMMUNITY): formContract.ori_tras_community_id
                        }}>
                        {communityToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {i18n.language==="es"?option.namees:option.nameen}
                            </option>
                        ))}
                    </TextField>
                </div>
            </div> 
            
            <Typography style={{color:"#067330", fontSize: 16}} >  
                {t('Text_CONTRACT_ADDRESS_FISCAL')}
            </Typography>
            <hr className="sidebar-divider d-none d-md-block"/>
            <div className="row p-2"> 
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_RoadType')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="ori_tras_roadtype_id_fiscal"
                        name="ori_tras_roadtype_id_fiscal"
                        value={ (formContract.ori_tras_roadtype_id_fiscal === undefined || formContract.ori_tras_roadtype_id_fiscal ===null || formContract.ori_tras_roadtype_id_fiscal ===""
                            || formContract.ori_tras_roadtype_id_fiscal ==="0" || formContract.ori_tras_roadtype_id_fiscal ===0)?Number(DEFAULTROADTYE):formContract.ori_tras_roadtype_id_fiscal}
                        inputProps={{ style: {width: i18n.language==='es'?150:150,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurSelectRoadType_Fiscal_Ori_Tras}
                        onChange={handleChangeSelectRoadTypeFiscal_Ori_Tras}
                        helperText={errorsForm.ori_tras_roadtype_id_fiscal!=null && errorsForm.ori_tras_roadtype_id_fiscal!==""?t(errorsForm.ori_tras_roadtype_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formContract.ori_tras_roadtype_id_fiscal === undefined || formContract.ori_tras_roadtype_id_fiscal ===null || formContract.ori_tras_roadtype_id_fiscal ===""
                                || formContract.ori_tras_roadtype_id_fiscal ==="0" || formContract.ori_tras_roadtype_id_fiscal ===0)?Number(DEFAULTROADTYE): formContract.ori_tras_roadtype_id_fiscal
                        }}>
                        <option key={0} value=""/>
                        {roadTypesToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {i18n.language==="es"?option.namees:option.nameen}
                            </option>
                        ))}
                    </TextField>  
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_ADDRESS')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="ori_tras_street_fiscal" 
                        name="ori_tras_street_fiscal"
                        value={formContract.ori_tras_street_fiscal}
                        inputProps={{ style: {width: i18n.language==='es'?449:462,  fontSize: '18px', }, maxLength: 250 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.ori_tras_street_fiscal!=null && errorsForm.ori_tras_street_fiscal!==""?t(errorsForm.ori_tras_street_fiscal):t('PlaceHolder_CONTRACT_ADDRESS')}
                        placeholder={t('PlaceHolder_CONTRACT_ADDRESS')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Ori_Tras}
                        onChange={handleChangeDataEditContract_Ori_Tras}
                    />
                </div>
                &nbsp;&nbsp;
                <IconButton  size="small" className="deletesmall-select-button" onClick={deleteDataStreetFiscalOriTras}>
                    <DeleteIcon style={{fontSize: 28}}/>
                </IconButton> 
                &nbsp;&nbsp;
                {(roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores')) && formContract.ori_tras_documentid!==undefined && formContract.ori_tras_documentid!=="") ?
                <IconButton  size="small" className={`edit-${
                        (formContract.ori_tras_store_id===undefined
                        || formContract.ori_tras_store_id===""
                        || formContract.ori_tras_store_id==="0"
                        || formContract.ori_tras_store_id===0 )
                        ? "noselect-button": "select-button" }`}
                        disabled={formContract.ori_tras_store_id===undefined
                        || formContract.ori_tras_store_id===""
                        || formContract.ori_tras_store_id==="0"
                        || formContract.ori_tras_store_id===0 }
                                onClick={searchFormStoreAddressFiscal}>
                    <SearchIcon style={{fontSize: 28}}/>
                    </IconButton>:
                    <IconButton  size="small" className="edit-noselect-button" disabled>
                        <SearchIcon style={{fontSize: 28}}/>
                    </IconButton> 
                }
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_PostalCode')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="ori_tras_postalcode_code_fiscal"
                            name="ori_tras_postalcode_code_fiscal"
                            value={formContract.ori_tras_postalcode_code_fiscal}
                            onChange={(e) => {
                                    setFormContract(prev => ({
                                    ...prev,
                                    ori_tras_postalcode_code_fiscal: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchPostalCodeFiscal(e.target.value);
                            }}
                            onKeyDown={handleKeyDownDPostalCodeOriTrasFiscal}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                    const inputPostalCode = formContract.ori_tras_postalcode_code_fiscal.trim().toUpperCase();
                                    const matchedPostal = postalCodeOriTrasFiscalToSelect.find((postal) => {
                                    const normalizedPostal = postal.postalcode?.toUpperCase() || "";
                                    return normalizedPostal === inputPostalCode;
                                    });

                                    if (matchedPostal) {
                                        setFormContract((prev) => ({
                                            ...prev,
                                            ori_tras_postalcode_id_fiscal: matchedPostal.id || Number(DEFAULTPOSTALCODE_ID),
                                            ori_tras_postalcode_code_fiscal: matchedPostal.postalcode || DEFAULTPOSTALCODE_CODE,
                                            ori_tras_postalcode_name_fiscal: matchedPostal.name || DEFAULTPOSTALCODE_NAME,
                                            ori_tras_province_id_fiscal: matchedPostal.province_id || Number(DEFAULTPROVINCE),
                                        }));
                                    } else {
                                        setFormContract((prev) => ({
                                            ...prev,
                                            ori_tras_postalcode_id_fiscal: Number(DEFAULTPOSTALCODE_ID),
                                            ori_tras_postalcode_code_fiscal: DEFAULTPOSTALCODE_CODE,
                                            ori_tras_postalcode_name_fiscal: DEFAULTPOSTALCODE_NAME,
                                            ori_tras_province_id_fiscal: Number(DEFAULTPROVINCE),
                                        }));
                                    }
                                    setFilteredpostalCodeOriTrasFiscal([]);
                                    setHighlightedIndexPostalCodeOriTrasFiscal(-1);
                                }
                            }}
                            label={errorsForm.ori_tras_postalcode_code_fiscal!=null && errorsForm.ori_tras_postalcode_code_fiscal!==""?t(errorsForm.ori_tras_postalcode_code_fiscal):t('Text_CONTRACT_PostalCode')}
                            placeholder={t('Text_CONTRACT_PostalCode')}
                            variant="standard"
                            inputProps={{ style: {width: i18n.language==='es'?100:100,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                        />  
                        {/* Desplegable dinámico */}
                        {filteredpostalCodeOriTrasFiscal.length > 0 && (
                            <div
                                className="dropdown-class"
                                style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                overflowY: "auto",
                                width: "350%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredpostalCodeOriTrasFiscal.map((postal, index) => (
                                <MenuItem
                                    key={postal.id}
                                    onClick={() => handleSelectPostalCodeOriTrasFiscal(postal)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexPostalCodeOriTrasFiscal ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexPostalCodeOriTrasFiscal ? "white" : "black",
                                    }}
                                >
                                    {postal.postalcode} - {postal.name}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_Locality')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="ori_tras_postalcode_name_fiscal" 
                        name="ori_tras_postalcode_name_fiscal"
                        value={formContract.ori_tras_postalcode_name_fiscal}
                        inputProps={{ style: {width: i18n.language==='es'?210:241,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.ori_tras_postalcode_name_fiscal!=null && errorsForm.ori_tras_postalcode_name_fiscal!==""?t(errorsForm.ori_tras_postalcode_name_fiscal):t('Text_CONTRACT_Locality')}
                        placeholder={t('Text_CONTRACT_Locality')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Ori_Tras}
                        onChange={handleChangeDataEditContract_Ori_Tras}
                        disabled
                    />  
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_Community')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="ori_tras_community_id_fiscal"
                        name="ori_tras_community_id_fiscal"
                        value={ (formContract.ori_tras_community_id_fiscal === undefined || formContract.ori_tras_community_id_fiscal ===null || formContract.ori_tras_community_id_fiscal ===""
                            || formContract.ori_tras_community_id_fiscal ==="0" || formContract.ori_tras_community_id_fiscal ===0)?Number(DEFAULTCOMMUNITY):formContract.ori_tras_community_id_fiscal}
                        inputProps={{ style: {width: i18n.language==='es'?200:200,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurSelectCommunityFiscal_Ori_Tras}
                        onChange={handleChangeSelectCommunityFiscal_Ori_Tras}
                        helperText={errorsForm.ori_tras_community_id_fiscal!=null  && errorsForm.ori_tras_community_id_fiscal!==""?t(errorsForm.ori_tras_community_id_fiscal):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formContract.ori_tras_community_id_fiscal === undefined || formContract.ori_tras_community_id_fiscal ===null || formContract.ori_tras_community_id_fiscal ===""
                                || formContract.ori_tras_community_id_fiscal ==="0" || formContract.ori_tras_community_id_fiscal ===0)?Number(DEFAULTCOMMUNITY): formContract.ori_tras_community_id_fiscal
                        }}>
                        {communityToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {i18n.language==="es"?option.namees:option.nameen}
                            </option>
                        ))}
                    </TextField>
                </div>
            </div>
            <hr className="sidebar-divider d-none d-md-block"/>
            <div className="row p-2"> 
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_Phone')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="ori_tras_phone" 
                        name="ori_tras_phone"
                        value={formContract.ori_tras_phone}
                        inputProps={{ style: {width: 180,  fontSize: '18px', }, maxLength: 30 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}    
                        label={errorsForm.ori_tras_phone!=null && errorsForm.ori_tras_phone!==""?t(errorsForm.ori_tras_phone):t('PlaceHolder_CONTRACT_Phone')}
                        placeholder={t('PlaceHolder_CONTRACT_Phone')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Ori_Tras}
                        onChange={handleChangeDataEditContract_Ori_Tras}
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_Email')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="ori_tras_email" 
                        name="ori_tras_email"
                        value={formContract.ori_tras_email}
                        inputProps={{ style: {width: i18n.language==='es'?319:335 ,  fontSize: '18px'}, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}     
                        label={errorsForm.ori_tras_email!=null && errorsForm.ori_tras_email!==""?t(errorsForm.ori_tras_email):t('PlaceHolder_CONTRACT_Email')}
                        placeholder={t('PlaceHolder_CONTRACT_Email')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Ori_Tras}
                        onChange={handleChangeDataEditContract_Ori_Tras}
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_NIMA')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="ori_tras_nima"
                            name="ori_tras_nima"
                            value={formContract.ori_tras_nima}
                            onChange={(e) => {
                                setFormContract(prev => ({
                                ...prev,
                                ori_tras_nima: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchOriTrasNima(e.target.value);
                            }}
                            onKeyDown={handleKeyDownOriTrasNima}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                handleBlur();
                                }
                            }}
                            label={errorsForm.ori_tras_nima!=null && errorsForm.ori_tras_nima!==""?t(errorsForm.ori_tras_nima):t('PlaceHolder_CONTRACT_NIMA')}
                            placeholder={t('PlaceHolder_CONTRACT_NIMA')}
                            variant="standard"
                            inputProps={{ style: {width: 133,  fontSize: '18px'}, maxLength: 50 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        />  
                        {/* Desplegable dinámico */}
                        {filteredOriTrasNima.length > 0 && (
                            <div
                                className="dropdown-class"
                                style={{
                                    position: "absolute",
                                    left:'0px',
                                    border: "2px solid #4e73df", // Borde azul (#4e73df)
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    maxWidth: "750px",
                                    overflowY: "auto",
                                    width: "140%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa", // Fondo gris claro
                                    zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredOriTrasNima.map((nt, index) => (
                                <MenuItem
                                    key={nt.id}
                                    onClick={() => handleSelectOriTrasNima(nt)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexOriTrasNima ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexOriTrasNima ? "white" : "black",
                                    }}
                                >
                                    {nt.nima}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>
                        &nbsp;&nbsp;
                    {(roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores')) && formContract.ori_tras_documentid!==undefined && formContract.ori_tras_documentid!=="") ?
                        <IconButton  size="small" className={`edit-${
                            (formContract.ori_tras_store_id===undefined
                            || formContract.ori_tras_store_id===""
                            || formContract.ori_tras_store_id==="0"
                            || formContract.ori_tras_store_id===0
                            )? "noselect-button": "select-button" }`}
                            disabled={formContract.ori_tras_store_id===undefined
                            || formContract.ori_tras_store_id===""
                            || formContract.ori_tras_store_id==="0"
                            || formContract.ori_tras_store_id===0} 
                            onClick={searchFormStoreNimaAddress}>
                            <SearchIcon style={{fontSize: 28}}/>
                        </IconButton>:
                        <IconButton  size="small" className="edit-noselect-button" disabled>
                            <SearchIcon style={{fontSize: 28}}/>
                        </IconButton> 
                    }
                </div>
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_INSCRIPTION')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="ori_tras_inscription" 
                        name="ori_tras_inscription"
                        value={formContract.ori_tras_inscription}
                        inputProps={{ style: {width:350,  fontSize: '18px'}, maxLength: 50 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}      
                        label={errorsForm.ori_tras_inscription!=null && errorsForm.ori_tras_inscription!==""?t(errorsForm.ori_tras_inscription):t('PlaceHolder_CONTRACT_INSCRIPTION')}
                        placeholder={t('PlaceHolder_CONTRACT_INSCRIPTION')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Ori_Tras}
                        onChange={handleChangeDataEditContract_Ori_Tras} 
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_OPT')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;  
                    <TextField
                        id="ori_tras_opt"
                        name="ori_tras_opt"
                        value={ (formContract.ori_tras_opt === undefined || formContract.ori_tras_opt ===null || formContract.ori_tras_opt ===""
                            || formContract.ori_tras_opt ==="0" || formContract.ori_tras_opt ===0)?0:formContract.ori_tras_opt}
                        inputProps={{ style: {width: i18n.language==='es'?194:171,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}     
                        variant="outlined"
                        onBlur={handleBlurDataEditContract_Ori_Tras}
                        onChange={handleChangeDataEditContract_Ori_Tras} 
                        helperText={errorsForm.ori_tras_opt!=null?t(errorsForm.ori_tras_opt):""}
                            select
                        SelectProps={{
                            native: true,
                            value: (formContract.ori_tras_opt === undefined || formContract.ori_tras_opt ===null || formContract.ori_tras_opt ===""
                                || formContract.ori_tras_opt ==="0" || formContract.ori_tras_opt ===0)?0: formContract.ori_tras_opt
                        }}>
                        <option key={0} value=""/>
                        {optTypeToSelect.map((option) => (
                        <option key={option.id} value={option.id}>
                            {option.code} - {option.namees.substring(0,20)}
                        </option>
                        ))}
                    </TextField>            
                </div>
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_GESTOR')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="ori_tras_grnp" 
                        name="ori_tras_grnp"
                        value={formContract.ori_tras_grnp}
                        inputProps={{ style: {width: i18n.language==='es'?684:250, fontSize: '18px'}, maxLength: 50 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.ori_tras_grnp!=null && errorsForm.ori_tras_grnp!==""?t(errorsForm.ori_tras_grnp):t('PlaceHolder_CONTRACT_GESTOR')}
                        placeholder={t('PlaceHolder_CONTRACT_GESTOR')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Ori_Tras}
                        onChange={handleChangeDataEditContract_Ori_Tras} 
                    />
                    
                </div>
            </div>  
 
            <Typography style={{color:"#067330", fontSize: 16}} >  
                {t('Text_CONTRACT_CONTACT_CHARGE')}
            </Typography>
            <hr className="sidebar-divider d-none d-md-block"/>
            <div className="row p-2"> 
                <div className="form-group"> 
                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_DocuentType')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="ori_tras_contactname_documnettype_id"
                        name="ori_tras_contactname_documnettype_id"
                        value={ (formContract.ori_tras_contactname_documnettype_id === undefined || formContract.ori_tras_contactname_documnettype_id ===null || formContract.ori_tras_contactname_documnettype_id ===""
                            || formContract.ori_tras_contactname_documnettype_id ==="0" || formContract.ori_tras_contactname_documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT):formContract.ori_tras_contactname_documnettype_id}
                        inputProps={{ style: {width: 200,  fontSize: '18px'}, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleChangeSelectDocumentTypeEmployee_Ori_Tras}
                        onChange={handleBlurSelectDocumentTypeEmployee_Ori_Tras}
                        helperText={errorsForm.ori_tras_contactname_documnettype_id!=null && errorsForm.ori_tras_contactname_documnettype_id!==""?t(errorsForm.ori_tras_contactname_documnettype_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formContract.ori_tras_contactname_documnettype_id === undefined || formContract.ori_tras_contactname_documnettype_id ===null || formContract.ori_tras_contactname_documnettype_id ===""
                                || formContract.ori_tras_contactname_documnettype_id ==="0" || formContract.ori_tras_contactname_documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT): formContract.ori_tras_contactname_documnettype_id
                        }}>
                        <option key={0} value=""/>
                        {documentTypesToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {option.name}
                            </option>
                        ))}
                    </TextField>  
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_CIF')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;  
                    <TextField
                        id="ori_tras_contactname_documentid" 
                        name="ori_tras_contactname_documentid"
                        value={formContract.ori_tras_contactname_documentid}
                        inputProps={{ style: {width: i18n.language==='es'?283:323,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.ori_tras_contactname_documentid!=null && errorsForm.ori_tras_contactname_documentid!==""?t(errorsForm.ori_tras_contactname_documentid):t('PlaceHolder_CONTRACT_CIF')}
                        placeholder={t('PlaceHolder_CONTRACT_CIF')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Ori_Tras}
                        onChange={handleChangeDataEditContract_Ori_Tras} 
                    />
                    &nbsp;&nbsp;
                    <IconButton  size="small" className="deletesmall-select-button"   onClick={deleteDateEmployeeOriTras}>
                        <DeleteIcon style={{fontSize: 28}}/>
                    </IconButton> 
                    &nbsp;&nbsp;
                    {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores'))&&
                      <IconButton  size="small" className="edit-select-button" onClick={searchFormEmployee}>
                            <SearchIcon style={{fontSize: 28}}/>
                        </IconButton> 
                    }
                </div>
                <div className="form-group"> 
                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_EMPLOYEEE_firstname')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="ori_tras_contactname_firstaname" 
                        name="ori_tras_contactname_firstaname"
                        value={formContract.ori_tras_contactname_firstaname}
                        inputProps={{ style: {width: i18n.language==='es'?357:382,  fontSize: '18px'}, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.ori_tras_contactname_firstaname!=null && errorsForm.ori_tras_contactname_firstaname!==""?t(errorsForm.ori_tras_contactname_firstaname):t('PlaceHolder_CONTRACT_EMPLOYEEE_firstname')}
                        placeholder={t('PlaceHolder_CONTRACT_EMPLOYEEE_firstname')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Ori_Tras}
                        onChange={handleChangeDataEditContract_Ori_Tras} 
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_EMPLOYEEE_lastname1')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;  
                    <TextField
                        id="ori_tras_contactname_lastname1" 
                        name="ori_tras_contactname_lastname1"
                        value={formContract.ori_tras_contactname_lastname1}
                        inputProps={{ style: {width: i18n.language==='es'?357:382,  fontSize: '18px'}, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.ori_tras_contactname_lastname1!=null && errorsForm.ori_tras_contactname_lastname1!==""?t(errorsForm.ori_tras_contactname_lastname1):t('PlaceHolder_CONTRACT_EMPLOYEEE_lastname1')}
                        placeholder={t('PlaceHolder_CONTRACT_EMPLOYEEE_lastname1')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Ori_Tras}
                        onChange={handleChangeDataEditContract_Ori_Tras} 
                    />
                </div>
                <div className="form-group">  
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_EMPLOYEEE_lastname2')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="ori_tras_contactname_lastname2" 
                        name="ori_tras_contactname_lastname2"
                        value={formContract.ori_tras_contactname_lastname2}
                        inputProps={{ style: {width: i18n.language==='es'?357:382,  fontSize: '18px'}, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.ori_tras_contactname_lastname2!=null && errorsForm.ori_tras_contactname_lastname2!==""?t(errorsForm.ori_tras_contactname_lastname2):t('PlaceHolder_CONTRACT_EMPLOYEEE_lastname2')}
                        placeholder={t('PlaceHolder_CONTRACT_EMPLOYEEE_lastname2')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Ori_Tras}
                        onChange={handleChangeDataEditContract_Ori_Tras} 
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text" style={{color:"#067330", fontSize: 18 }}>{t('Text_CONTRACT_EMPLOYEEE_position')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="ori_tras_contactname_position" 
                        name="ori_tras_contactname_position"
                        value={formContract.ori_tras_contactname_position}
                        inputProps={{ style: {width: i18n.language==='es'?353:367,  fontSize: '18px'}, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.ori_tras_contactname_position!=null && errorsForm.ori_tras_contactname_position!==""?t(errorsForm.ori_tras_contactname_position):t('PlaceHolder_CONTRACT_EMPLOYEEE_position')}
                        placeholder={t('PlaceHolder_CONTRACT_EMPLOYEEE_position')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Ori_Tras}
                        onChange={handleChangeDataEditContract_Ori_Tras} 
                    />
                </div>
                <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_Phone')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="ori_tras_contactname_phone" 
                        name="ori_tras_contactname_phone"
                        value={formContract.ori_tras_contactname_phone}
                        inputProps={{ style: {width: i18n.language==='es'?200:200, fontSize: '18px'}, maxLength: 30 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.ori_tras_contactname_phone!=null && errorsForm.ori_tras_contactname_phone!==""?t(errorsForm.ori_tras_contactname_phone):t('PlaceHolder_CONTRACT_Phone')}
                        placeholder={t('PlaceHolder_CONTRACT_Phone')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Ori_Tras}
                        onChange={handleChangeDataEditContract_Ori_Tras} 
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_Email')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="ori_tras_contactname_email" 
                        name="ori_tras_contactname_email"
                        value={formContract.ori_tras_contactname_email}
                        inputProps={{ style: {width: i18n.language==='es'?587:603, fontSize: '18px'}, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}     
                        label={errorsForm.ori_tras_contactname_email!=null && errorsForm.ori_tras_contactname_email!==""?t(errorsForm.ori_tras_contactname_email):t('PlaceHolder_CONTRACT_Email')}
                        placeholder={t('PlaceHolder_CONTRACT_Email')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Ori_Tras}
                        onChange={handleChangeDataEditContract_Ori_Tras}
                    /> 
                </div>
                 <div className="form-group"> 
                   
                </div>
            </div> 
            <ContractSearchStores
                showModalSearchStores={showModalSearchStores}
                setShowModalSearchStores={setShowModalSearchStores}
                selectStores={"Ori_Tras"}
                setFormContract={setFormContract}
            />
            <ContractSearchStoresAddresses
                showModalSearchStoresAddress={showModalSearchStoresAddress}
                setShowModalSearchStoresAddress={setShowModalSearchStoresAddress}
                selectStores={tetxtSearch}
                setFormContract={setFormContract}
                titleTable={formContract.ori_tras_tradename}
                store_id={formContract.ori_tras_store_id}
                priority={priority}
            />
            <ContractSearchStoresNimaAddresses
                showModalSearchStoresNimaAddress={showModalSearchStoresNimaAddress}
                setShowModalSearchStoresNimaAddress={setShowModalSearchStoresNimaAddress}
                selectStores={tetxtSearch}
                setFormContract={setFormContract}
                titleTable={formContract.ori_tras_tradename}
                store_id={formContract.ori_tras_store_id} 
            />
             <ContractSearchEmployees
                showModalSearchEmployees={showModalSearchEmployees}
                setShowModalSearchEmployees={setShowModalSearchEmployees}
                setFormContract={setFormContract}
            />
            
        </> 
    )
}

ContractCreateOrEditOriTras.propTypes = {
    formContract: PropTypes.object.isRequired,
    setFormContract: PropTypes.func.isRequired,
    setIsLoadingErrorData: PropTypes.func.isRequired,
    errorsForm: PropTypes.object.isRequired,
    setErrorsForm: PropTypes.func.isRequired,
    validateFormContract: PropTypes.func.isRequired,
    documentTypesToSelect: PropTypes.array.isRequired,
    roadTypesToSelect: PropTypes.array.isRequired,
    communityToSelect: PropTypes.array.isRequired,
    optTypeToSelect: PropTypes.array.isRequired
  };
  
  export default ContractCreateOrEditOriTras;

